import {escapeRegex} from 'common/regex.js';
import ko from 'knockout';

const selectFilterTemplate = `
<div class="row form-group">
    <div class="col-md-6">
        <input
            autocomplete="off"
            type="text"
            data-bind="
                textInput: filter,
                attr: {id: id, placeholder: placeholder},
                event: {keydown: keydown}
            "
            class="textinput textInput form-control"
        >
        <i class="fa fa-search dashboard-search"></i>
    </div>
</div>
<div class="row">
    <div class="col-md-6">
        <ul
            data-bind="foreach: filteredOptions"
            class="
                select-filter
                list-unstyled
                selectmultiple
                form-control
                margin-sm-bottom
        ">
            <li>
                <div class="media">
                    <div
                        class="media-body media-middle"
                        data-bind="html: display"
                    ></div>
                    <div class="media-right media-middle">
                        <button
                            class="btn btn-primary text-16"
                            type="button"
                            data-bind="click: $parent.add"
                        >
                            <i class="fa fa-plus"></i>
                        </button>
                    </div>
                </div>
            </li>
        </ul>
    </div>
    <div
        class="col-md-6"
        data-bind="css: {'selected-items': addedOptions() < 1}"
    >
        <div class="hidden-md hidden-lg filter-header">
            <h4 data-bind="text: header"></h4>
            <p data-bind="text: help"></p>
        </div>
        <ul
            data-bind="foreach: addedOptions"
            class="
                select-filter
                selected
                list-unstyled
                selectmultiple
                form-control
                margin-sm-bottom
            "
        >
            <li>
                <div class="media">
                    <div
                        class="media-body media-middle"
                        data-bind="html: display"
                    ></div>
                    <div class="media-right media-middle">
                        <button
                            class="btn btn-primary text-16"
                            type="button"
                            data-bind="click: $parent.remove"
                        >
                            <i class="fa fa-minus"></i>
                        </button>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</div>`;

class SelectFilterModel {
    constructor(params) {
        this.defaultPlaceholder =
            'Search for a value to filter the list below';
        this.options = params.options;
        this.id = params.id;
        this.filter = ko.observable('');
        this.placeholder =
            ko.unwrap(params.placeholder) || this.defaultPlaceholder;
        this.header = params.header;
        this.help = params.help;
        this.params = params;

        this.filteredOptions = ko.pureComputed(() => {
            const opts = ko.unwrap(this.options);
            const filteredOpts = [];
            for (const opt of opts) {
                const optText = this.displayText(opt);
                // Is it filtered out?
                let filterText;
                if (params.filterText) {
                    filterText = opt[ko.unwrap(params.filterText)];
                } else {
                    filterText = optText;
                }
                filterText = ko.unwrap(filterText);
                if (this.filter()) {
                    const re = new RegExp(
                        `\\b${escapeRegex(this.filter())}`,
                        'i',
                    );
                    if (!re.test(filterText)) {
                        continue;
                    }
                }
                // Is it already selected?
                let selected = false;
                for (const val of ko.unwrap(params.value)) {
                    if (val === opt) {
                        selected = true;
                        break;
                    }
                }
                if (selected) {
                    continue;
                }
                // Else add to list to display
                const theOpt = {
                    option: opt,
                    display: optText,
                };
                filteredOpts.push(theOpt);
            }
            return filteredOpts;
        });

        this.addedOptions = ko.pureComputed(() => {
            const added = ko.unwrap(params.value);
            const addedOpts = [];
            for (const opt of added) {
                addedOpts.push({
                    option: opt,
                    display: this.displayText(opt),
                });
            }
            return addedOpts;
        });

        this.add = this.add.bind(this);
        this.remove = this.remove.bind(this);
        this.keydown = this.keydown.bind(this);
    }

    displayText(opt) {
        let optText;
        if (this.params.optionsText) {
            optText = opt[ko.unwrap(this.params.optionsText)];
        } else {
            optText = opt.toString ? opt.toString() : opt;
        }
        if (typeof optText === 'function') {
            optText = optText();
        }
        return optText;
    }

    add(optData) {
        this.params.value.push(optData.option);
    }

    remove(optData) {
        this.params.value.remove(optData.option);
    }

    keydown(_, event) {
        const key = event.key || event.keyCode || event.which;
        if (key === 13 || key === 'Enter') {
            if (this.filteredOptions().length) {
                this.add(this.filteredOptions()[0]);
            }
        } else {
            // Process event normally
            return true;
        }
    }
}

ko.components.register('select-filter', {
    viewModel: SelectFilterModel,
    template: selectFilterTemplate,
});
